import { render, staticRenderFns } from "./ExtractList.vue?vue&type=template&id=0f9f5a33"
import script from "./ExtractList.vue?vue&type=script&lang=js"
export * from "./ExtractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports